if (!customElements.get("td-menu")) {
  class TdMenu extends HTMLElement {
    constructor() {
      super();

      this.TRIGGERS = this.querySelectorAll('[data-td-trigger]');
    }

    connectedCallback() {
      this.attachListeners();
    }
    
    attachListeners() {
      this.TRIGGERS.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
          this.toggleMenuItem(trigger, true)
        })
        trigger.addEventListener('mouseleave', () => {
          setTimeout(() => {
            this.toggleMenuItem(trigger, false)
          }, 300);
        })
      })
    }

    toggleMenuItem(trigger, isHovered) {
      if (isHovered) {
        trigger.classList.add('td-active')
      } else {
        trigger.classList.remove('td-active')
      }
    }
  }

  customElements.define("td-menu", TdMenu);
}